import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M17 3C18.6569 3 20 4.34315 20 6V18C20 19.6569 18.6569 21 17 21H7C5.34315 21 4 19.6569 4 18V6C4 4.34315 5.34315 3 7 3H17ZM8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H10C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16H8ZM8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H8ZM8 6C7.44772 6 7 6.44772 7 7V9C7 9.55228 7.44772 10 8 10H10C10.5523 10 11 9.55228 11 9V7C11 6.44772 10.5523 6 10 6H8Z'
            fill='currentColor'
        />
    </svg>
);

export const DocumentIcon = styled(Icon)({});
